import { mutatorAction } from 'satcheljs';
import getStore from '../store';
import type AttachmentPreview from 'owa-service/lib/contract/AttachmentPreview';
import type ItemId from 'owa-service/lib/contract/ItemId';
import type ConversationNode from 'owa-service/lib/contract/ConversationNode';

export const setConversationAttachmentPreviews = mutatorAction(
    'setConversationAttachmentPreviews',
    (conversationId: ItemId, attachments: AttachmentPreview[]) => {
        getStore().attachmentPreviews.set(conversationId.Id, attachments);
    }
);

export const setUnreadReplies = mutatorAction(
    'setUnreadReplies',
    (conversationId: ItemId, replies: ConversationNode[]) => {
        getStore().unreadReplies.set(conversationId.Id, replies);
    }
);
